var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-tooltip", {
    attrs: {
      title: _vm.$t(_vm.title),
      placement: "right"
    }
  }, [_c("span", {
    staticClass: "menu-title",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.title)))])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };